import { Routes } from '@angular/router';
import { DepartmentFormComponent } from './components/department/department-form/department-form.component';
import { ServiceAreaListComponent } from './components/serviceArea/service-area-list/service-area-list.component';
import { ServiceAreaFormComponent } from './components/serviceArea/service-area-form/service-area-form.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { HomeComponent } from './components/home/home.component';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { AuditLogsComponent } from './components/audit-logs/audit-logs.component';
import { OrganizationFormComponent } from './components/organization/organization-form/organization-form.component';
import { KnowledgeBaseItemListComponent } from './components/knowledgeBaseItem/knowledge-base-item-list/knowledge-base-item-list.component';
import { KnowledgeBaseItemFormComponent } from './components/knowledgeBaseItem/knowledge-base-item-form/knowledge-base-item-form.component';
import { DepartmentListComponent } from './components/department/department-list/department-list.component';

export const routes: Routes = [
    {
      path: '',
      canActivate: [MsalGuard], // Protect the root path
      children: [
        { path: '', component: HomeComponent },
        
        { path: 'organization', component: OrganizationFormComponent },

        { path: 'departments', component: DepartmentListComponent },
        { path: 'departments/create', component: DepartmentFormComponent },
        { path: 'departments/edit/:id', component: DepartmentFormComponent },

        { path: 'service-areas', component: ServiceAreaListComponent },
        { path: 'service-areas/create', component: ServiceAreaFormComponent },
        { path: 'service-areas/edit/:id', component: ServiceAreaFormComponent },        

        { path: 'knowledge-base-items/:serviceAreaId', component: KnowledgeBaseItemListComponent },
        { path: 'knowledge-base-item/create/:serviceAreaId', component: KnowledgeBaseItemFormComponent },
        { path: 'knowledge-base-item/edit/:id', component: KnowledgeBaseItemFormComponent },

        { path: 'audit-logs', component: AuditLogsComponent },
        
      ],
    },    
    { path: 'login-failed', component: LoginFailedComponent },
    { path: 'auth', component: MsalRedirectComponent }, // Redirect URI route
    { path: '**', redirectTo: '', pathMatch: 'full' },// Fallback for invalid paths
  ];